/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyCountry
 */
export interface WriteOnlyCountry {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyCountry
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyCountry
     */
    iso2: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyCountry
     */
    iso3: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyCountry
     */
    timeZone: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyCountry
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyCountry
     */
    vatRate: number;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyCountry
     */
    tachoAlpha?: string;
}

export function WriteOnlyCountryFromJSON(json: any): WriteOnlyCountry {
    return WriteOnlyCountryFromJSONTyped(json, false);
}

export function WriteOnlyCountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyCountry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'iso2': json['iso2'],
        'iso3': json['iso3'],
        'timeZone': json['time_zone'],
        'currency': json['currency'],
        'vatRate': json['vat_rate'],
        'tachoAlpha': !exists(json, 'tacho_alpha') ? undefined : json['tacho_alpha'],
    };
}

export function WriteOnlyCountryToJSON(value?: WriteOnlyCountry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'iso2': value.iso2,
        'iso3': value.iso3,
        'time_zone': value.timeZone,
        'currency': value.currency,
        'vat_rate': value.vatRate,
        'tacho_alpha': value.tachoAlpha,
    };
}


